export default "__VITE_ASSET__JrMk2GEr__"